import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import {
  Grid,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core'

// actions
import {
  getTolerances,
  updateTolerance,
  addWeightTolerance,
  deleteWeightTolerance,
} from '../../../actions/weightTolerance'

// utils
import { isValidString } from '../../../utils/string'
import { hasAccess } from '../../../utils/api'

// local components
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import ToleranceItemContainer from '../../../components/WeightTolerance/ToleranceItemContainer'
import { openErrorMessage } from '../../../actions/message'
import { Appcues } from '../../../utils/constants'

const emptyTolerance = {
  name: '',
  startWeight: 0,
  endWeight: 0,
  unitValue: 0,
  enabled: false,
  weightKey: 'CUSTOM',
}

class CompanyWrightTolerances extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showEmptyTolerance: false,
    }
  }

  componentDidMount() {
    this.props.dispatch(getTolerances())
  }

  onToleranceUpdate = (data, afterOnSave) => {
    if (!isValidString(data.name)) {
      return this.props.dispatch(openErrorMessage('Please enter a valid name'))
    }
    this.props.dispatch(updateTolerance(data)).then((response) => {
      Appcues.track('Weight Tolerance updated')
      this.props.dispatch(getTolerances())
      afterOnSave(response)
    })
  }

  toggleEmptyTolerance = () => {
    Appcues.track('Adding Tolerance')
    this.setState((prevState) => ({
      showEmptyTolerance: !prevState.showEmptyTolerance,
    }))
  }

  addWeightTolerance = (data, afterOnSave) => {
    const updatedData = { ...data }
    delete updatedData.weightKey
    if (!isValidString(updatedData.name)) {
      return this.props.dispatch(openErrorMessage('Please enter a valid name'))
    }
    this.props.dispatch(addWeightTolerance(updatedData)).then((response) => {
      Appcues.track('Weight Tolerance added')
      this.props.dispatch(getTolerances())
      afterOnSave(response)
      this.toggleEmptyTolerance()
    })
  }

  onDelete = (toleranceId) => () => {
    this.props.dispatch(deleteWeightTolerance(toleranceId)).then((response) => {
      Appcues.track('Weight Tolerance deleted')
      this.props.dispatch(getTolerances())
    })
  }

  render() {
    const { tolerances = {}, lastModified = {} } = this.props.weightToleranceReducer

    const { showEmptyTolerance } = this.state

    const { values = [] } = tolerances

    return (
      <Fragment>
        <Grid container>
          <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
            <Grid container>
              <Grid item xs={12}>
                {hasAccess() ? (
                  <Button
                    variant="raised"
                    className="primary-button pull-right margin-bottom-small"
                    onClick={this.toggleEmptyTolerance}
                  >
                    Add Tolerance
                  </Button>
                ) : null}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper>
              <div className="table-scroll">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Start Range</TableCell>
                      <TableCell>End Range</TableCell>
                      <TableCell>Default Value</TableCell>
                      <TableCell>Enabled</TableCell>
                      {hasAccess() ? <TableCell></TableCell> : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {showEmptyTolerance ? (
                      <ToleranceItemContainer
                        tolerance={emptyTolerance}
                        lastModified={lastModified}
                        onToleranceUpdate={this.addWeightTolerance}
                        defaultEditMode={true}
                        onCancel={this.toggleEmptyTolerance}
                      />
                    ) : null}
                    {values.map((row, index) => {
                      return (
                        <ToleranceItemContainer
                          key={index}
                          tolerance={row}
                          lastModified={lastModified}
                          onToleranceUpdate={this.onToleranceUpdate}
                          onDelete={this.onDelete(row.id)}
                        />
                      )
                    })}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Fragment>
    )
  }
}

export default connect(({ dispatch, weightToleranceReducer }) => ({
  dispatch,
  weightToleranceReducer,
}))(ContainerWithTitle(CompanyWrightTolerances, 'Weight Tolerances'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/CompanyWeightTolerances.js